import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PurchaseRoutingModule } from './purchase-routing.module';
import { AppSharedModule } from '@app/shared/app-shared.module';
import { AppCommonModule } from '@app/shared/common/app-common.module';
import { SubheaderModule } from '@app/shared/common/sub-header/subheader.module';
import { FormsModule } from '@angular/forms';
import { Angular2CountoModule } from '@awaismirza/angular2-counto';
import { BsDatepickerModule, BsDatepickerConfig, BsDaterangepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'primeng/tooltip';
import { UtilsModule } from '@shared/utils/utils.module';
import { NgxBootstrapDatePickerConfigService } from 'assets/ngx-bootstrap/ngx-bootstrap-datepicker-config.service';
import { CreateOrEditVendorComponent } from './vendors/create-or-edit-vendor.component';
import { VendorsComponent } from './vendors/vendors.component';
import { FileUploadModule } from 'primeng/fileupload';
import { CreateOrEditPurchaseOrderComponent } from './purchaseOrders/create-or-edit-purchaseOrder.component';
import { PurchaseOrdersComponent } from './purchaseOrders/purchaseOrders.component';
import { CreateOrEditPurchaseInvoiceComponent } from './purchaseInvoices/create-or-edit-purchaseInvoice.component';
import { PurchaseInvoicesComponent } from './purchaseInvoices/purchaseInvoices.component';
import { CreateOrEditPurchaseReturnComponent } from './purchaseReturns/create-or-edit-purchaseReturn.component';
import { PurchaseReturnsComponent } from './purchaseReturns/purchaseReturn.component';
import { CreateOrEditVendorPaymentComponent } from './vendorPayments/create-or-edit-vendorPayment.component';
import { VendorPaymentsComponent } from './vendorPayments/vendorPayments.component';
import { DailyPurchaseComponent } from './reports/daily-purchase/daily-purchase.component';
import { VendorPurchaseComponent } from './reports/vendor-purchase/vendor-purchase.component';
import { DepartmentPurchaseComponent } from './reports/department-purchase/department-purchase.component';
import { ItemPurchaseComponent } from './reports/item-purchase/item-purchase.component';
import { AgedPayableDetailsComponent } from './reports/aged-payable-details/aged-payable-details.component';
import { AgedPayableComponent } from './reports/aged-payable/aged-payable.component';
import { PurchaseDetailComponent } from './reports/purchase-detail/purchase-detail.component';
import { VendorStatementComponent } from './reports/vendor-statement/vendor-statement.component';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { MultiSelectModule } from 'primeng/multiselect';

// import { SearchProductComponent } from '../shared/component/search-product/search-product.component';
// import { SearchVendorComponent } from '../shared/component/search-vendor/search-vendor.component';


@NgModule({
  declarations: [
    VendorsComponent,
    CreateOrEditVendorComponent,
    PurchaseOrdersComponent,
        CreateOrEditPurchaseOrderComponent,
        PurchaseInvoicesComponent,
        CreateOrEditPurchaseInvoiceComponent,
        CreateOrEditPurchaseReturnComponent,
        PurchaseReturnsComponent,
        CreateOrEditVendorPaymentComponent,
        VendorPaymentsComponent,
        DailyPurchaseComponent,
        VendorPurchaseComponent,
        DepartmentPurchaseComponent,
        ItemPurchaseComponent,
        AgedPayableDetailsComponent,
        AgedPayableComponent,
        PurchaseDetailComponent,
        VendorStatementComponent,
        
  ],
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule,
    CardModule,
    ModalModule,
    TabsModule,
    TooltipModule,
    AppCommonModule,
    UtilsModule,
    AppSharedModule,
    PurchaseRoutingModule,
    FileUploadModule,
    Angular2CountoModule,
    MultiSelectModule,
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
    SubheaderModule
],
  providers: [
    { provide: BsDatepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerConfig },
    { provide: BsDaterangepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDaterangepickerConfig },
    { provide: BsLocaleService, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerLocale },
  ],
})
export class PurchaseModule { }
